import { periodFormat } from 'utils/common';

export const createReqBody = filter => {
  return {
    filters: {
      search: filter.search ? filter.search : '*',
      plan: filter.plan[0] ? filter.plan : '*',
      status: filter.status[0] ? filter.status : '*',
      billingCycle: filter.billingCycle[0] ? filter.billingCycle : '*',
      cancellationReason: filter.cancellationReason[0]
        ? filter.cancellationReason
        : '*',
      accountManager: filter.accountManager[0] ? filter.accountManager : '*',
      customerSuccessEngineer: filter.customerSuccessEngineer[0]
        ? filter.customerSuccessEngineer
        : '*',
      companySize: filter.companySize[0] ? filter.companySize : '*',
      healthStatus: filter.healthStatus[0] ? filter.healthStatus : '*',
      arr: {
        from: filter.arr.from ? filter.arr.from : '*',
        to: filter.arr.to ? filter.arr.to : '*'
      },
      ageInMonths: {
        from: filter.ageInMonths.from ? filter.ageInMonths.from : '*',
        to: filter.ageInMonths.to ? filter.ageInMonths.to : '*'
      },
      likelyToReturn: {
        from: filter.likelyToReturn.from ? filter.likelyToReturn.from : '*',
        to: filter.likelyToReturn.to ? filter.likelyToReturn.to : '*'
      },
      cancellationLag: {
        from: filter.cancellationLag.from ? filter.cancellationLag.from : '*',
        to: filter.cancellationLag.to ? filter.cancellationLag.to : '*'
      },
      requestedAt: periodFormat(filter.requestedAt),
      nextBillingAt: periodFormat(filter.nextBillingAt),
      requestRemovedAt: periodFormat(filter.requestRemovedAt),
      requestedByRole: filter.requestedByRole[0] ? filter.requestedByRole : '*'
    },
    sort: {
      fieldName: filter.fieldName,
      direction: filter.direction
    }
  };
};

export const createMember = user => {
  return {
    fullName: user.requestedByName,
    email: user.requestedByEmail,
    department: user.requestedByRole
  };
};
